import { Menu, X } from "lucide-react";
import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { useAuth } from "../../features/auth/AuthContext";

const links = [
  ["About", "/about"],
  ["How It Works", "/#how-it-works"],
  ["Get Involved", "/get-involved"],
] as const;

export function SiteHeader() {
  const [open, setOpen] = useState(false);
  const auth = useAuth();
  return (
    <header className="site-header">
      <a className="skip-link" href="#main-content">
        Skip to main content
      </a>
      <div className="site-shell header-inner">
        <Link className="brand" to="/" aria-label="Guiding Stars home">
          <img className="brand-logo" src="/images/guiding-stars-official-logo.png" alt="" />
          <span>
            <strong>Guiding Stars</strong>
            <small>An internal program of The Guided Pathway Foundation</small>
          </span>
        </Link>
        <nav className={open ? "main-nav is-open" : "main-nav"} aria-label="Primary navigation">
          {links.map(([label, path]) => (
            <NavLink key={path} to={path} onClick={() => setOpen(false)}>
              {label}
            </NavLink>
          ))}
          <Link
            className="nav-sign-in"
            to={auth.user ? "/atlas" : "/sign-in"}
            onClick={() => setOpen(false)}
          >
            My Atlas
          </Link>
        </nav>
        <button
          className="menu-button"
          type="button"
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          onClick={() => setOpen((value) => !value)}
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>
    </header>
  );
}
